<template>
  <LoaderIcon v-if="loading" />
  <div v-if="!loading">
    <div v-if="tgChat && tgChat.userLogin != null">
      Подключен <a :href="'https://t.me/' + tgChat.userLogin" target="_blank">@{{ tgChat.userLogin }}</a>
    </div>
    <div v-else class="block">
      <p class="my-5">Не подключен</p>
      <a :href="connectLink" target="_blank" class="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
        Подключить
      </a>
    </div>
  </div>
</template>

<script>
import store from '@/store.js'
import LoaderIcon from "@/components/LoaderIcon.vue";

export default {
  name: 'ProfileTgBot',
  components: {LoaderIcon},
  data() {
    return {
      store,
      loading: true,
      tgChat: null
    }
  },
  computed: {
    connectLink() {
      return 'https://t.me/' + this.tgChat.botName +'?start=' + this.tgChat.authToken;
    }
  },
  methods: {
    load: function () {
      console.log("load")
      let c = this;
      this.loading = true;
      c.tgChat = null;
      this.axios.get('/api/profile/start-bot-link').then(function(response) {
        console.log(response.data);
        c.tgChat = response.data.data;
      }).catch(function(err) {
        console.log(err.status);
      }).finally(function() {
        c.loading = false;
      });
    }
  },
  mounted() {
    this.load()
  }
}
</script>

<style scoped>

</style>